export const MercedesArrowBack = (props) => (
    <svg 
        width={props.size || 9} 
        height={props.size || 15} 
        viewBox="0 0 9 15" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        {...props}>
            <path d="M7 14.2L0 7.1L7 0L8.4 1.4L2.8 7.1L8.4 12.7L7 14.2Z" fill="#414141"/>
    </svg>
);